import type { ReactElement } from 'react';
import { Link, useConfig, useNavigate, useServices, useT } from '../../../app/di';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Card } from '../../../ui-kit/Card/Card';
import { PreferencesControls } from '../../platform/user-preferences';
import { AuthLayout } from './AuthLayout/AuthLayout';
import { RegisterForm } from './RegisterForm/RegisterForm';

// IAM-UC-14, IAM-UC-14.CC-1, IAM-UC-14.CC-4: регистрация, пока открыта функция «Свободная регистрация».
export function RegisterPage(): ReactElement {
  const { session } = useServices();
  const { t } = useT();
  const navigate = useNavigate();
  const open = useConfig().features.registration;

  return (
    <AuthLayout>
      <Card title={t('identity.register.title')}>
        {open ? (
          <div className="u-stack">
            <p className="u-muted u-small">{t('identity.register.text')}</p>
            <RegisterForm
              onSubmit={async (registration) => {
                const result = await session.register(registration);
                // Блогов у нового пользователя нет — «Мои блоги» предложат создать первый.
                if (result.success) navigate('blogs', {}, { replace: true });
                return result;
              }}
            />
          </div>
        ) : (
          <Alert tone="info" title={t('identity.register.closedTitle')}>
            {t('identity.register.closed')}
          </Alert>
        )}
        <p className="u-small">
          {t('identity.register.haveAccount')} <Link to="login">{t('identity.register.toLogin')}</Link>
        </p>
      </Card>
      <Card>
        <PreferencesControls compact />
      </Card>
    </AuthLayout>
  );
}
